// services/QuestionCategoryService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getQuestionCategories(params = {}) {
    return api.get(ENDPOINTS.QUESTION_CATEGORIES.BASE, { params });
}
export function createQuestionCategory(payload) {
    return api.post(ENDPOINTS.QUESTION_CATEGORIES.BASE, payload);
}
export function updateQuestionCategory(id, payload) {
    return api.patch(ENDPOINTS.QUESTION_CATEGORIES.BY_ID(id), payload);
}
export function deleteQuestionCategory(id) {
    return api.delete(ENDPOINTS.QUESTION_CATEGORIES.BY_ID(id));
}
export function restoreQuestionCategory(id) {
    return api.post(`${ENDPOINTS.QUESTION_CATEGORIES.BY_ID(id)}/restore`);
}
